import React, { useState } from "react";
import { SystemContext } from "./context";

import {
    AppBar,
    Avatar,
    Box,
    CssBaseline,
    IconButton,
    Toolbar,
    Tooltip,
    Typography,
} from "@mui/material";
import appConfig from "./config";
// import { logout } from "@carrier/reactauthwrapper";
import { logout } from '@carrier-sce-sharedpackages/auth-module';

import { Logout } from "@mui/icons-material";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useStyles from "./Style";
import getUsernameFromToken from "./User";
import logo from "./assets/logo.png";

import VerticalTabs from "./VerticalTabs"; // Importing VerticalTabs component


const SoundAndVibration = ({ fetchAPI }) => {
    const [numberOfRows, setNumberOfRows] = useState('');
    const [numberOfColumns, setNumberOfColumns] = useState('');
    const [numberOfDuplicateRows, setNumberOfDuplicateRows] = useState('');
    const [numberOfDuplicateColumns, setNumberOfDuplicateColumns] = useState('');
    const [noOfRowsAfterCleaning, setNoOfRowsAfterCleaning] = useState('');
    const [noOfColsAfterCleaning, setNoOfColsAfterCleaning] = useState('');
    const [statsData, setStatsData] = useState({});
    const [balancedCols, setBalancedCols] = useState([]);


    const [numericalModeValue, setNumericalModeValue] = useState("Mean");
    const [categoricalModeValue, setCategoricalModeValue] = useState("Mode");
    const [outliersValue, setOutliersValue] = useState("");
    const [fileObjects, setfileObjects] = useState([]);
    const [outlinerMethod, setOutlinerMethod] = useState('None');
    const [fileName, setFileName] = useState('');
    const [actualFileName, setActualFileName] = useState('');
    const [cleanedData, setCleanedData] = useState([]);
    const [allColumns, setAllColumns] = useState([]);
    const [numericalColumns, setNumericalColumns] = useState([]);
    const [stringColumns, setStringColumns] = useState([]);

    const [rawOrCleanData, setRawOrCleanData] = useState('raw');
    const [missingData, setMissingData] = useState([]);
    const [tempCleanData, setTempCleanData] = useState([]);

    const [taskToDo, setTaskToDo] = useState([]);

    const [numericalStatsCol, setNumericalStatsCol] = useState([]);
    const [numericalStatsData, setNumericalStatsData] = useState({});

    const [categoricalStatsCol, setCategoricalStatsCol] = useState([]);
    const [categoricalStatsData, setCategoricalStatsData] = useState({});

    const [taskToDoValue, setTaskToDoValue] = useState('');
    const [targetVariableValue, setTargetVariableValue] = useState('');
    const [scalingTechniqueValue, setScalingTechniqueValue] = useState('');
    const [featureValue, setFeatureValue] = useState([]);
    const [strategForFeatureSelectionValue, setStrategForFeatureSelectionValue] = useState('');


    const [images, setImages] = useState([]);
    const [table1Data, setTable1Data] = useState([]);
    const [table2Data, setTable2Data] = useState([]);
    const [table3Data, setTable3Data] = useState([]);
    const [modelName, setModelName] = useState("");



    const [numberOfModelsToTrain, setNumberOfModelsToTrain] = useState([]);
    const [keyMetricValue, setKeyMetricValue] = useState("");

    const [timeStampCols, setTimeStampCols] = useState([]);
    const [numericalCleanedCols, setNumericalCleanedCols] = useState([]);
    const [categoricalCleanedCols, setCategoricalCleanedCols] = useState([]);
    const [allCleanedCols, setAllCleanedCols] = useState([]);
    const [cleaningInfo, setCleaningInfo] = useState({})
    const [dupCols, setDupCols] = useState([])

    const [cleanFlag, setCleanFlag] = useState(false);
    const [menubar, setMenubar] = useState(false);

    const classes = useStyles();
    const username = getUsernameFromToken();
    const [showSidebar, setShowSidebar] = useState(false);
    const handleLogout = () => {
        sessionStorage.removeItem("user");
        logout(appConfig.api);
    };
    const [anchorEl, setAnchorEl] = React.useState(null);


    const [openDrawer, setOpenDrawer] = useState(true);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    
    
    return (
        <SystemContext.Provider value={{
            numberOfRows, setNumberOfRows, numberOfColumns, setNumberOfColumns,
            numberOfDuplicateRows, setNumberOfDuplicateRows,
            numberOfDuplicateColumns, setNumberOfDuplicateColumns, statsData, setStatsData,
            numericalModeValue, setNumericalModeValue, categoricalModeValue, setCategoricalModeValue,
            outliersValue, setOutliersValue, fileObjects, setfileObjects, outlinerMethod, setOutlinerMethod,
            fileName, setFileName, cleanedData, setCleanedData, allColumns, setAllColumns, categoricalStatsData, setCategoricalStatsData,
            numericalColumns, setNumericalColumns, stringColumns, setStringColumns, rawOrCleanData, setRawOrCleanData,
            missingData, setMissingData, tempCleanData, setTempCleanData, taskToDo, setTaskToDo, numericalStatsCol, setNumericalStatsCol,
            numericalStatsData, setNumericalStatsData, categoricalStatsCol, setCategoricalStatsCol, taskToDoValue, setTaskToDoValue,
            targetVariableValue, setTargetVariableValue, scalingTechniqueValue, setScalingTechniqueValue, featureValue, setFeatureValue, strategForFeatureSelectionValue, setStrategForFeatureSelectionValue,
            numberOfModelsToTrain, setNumberOfModelsToTrain, keyMetricValue, setKeyMetricValue,
            timeStampCols, setTimeStampCols, numericalCleanedCols, setNumericalCleanedCols,
            categoricalCleanedCols, setCategoricalCleanedCols, allCleanedCols, setAllCleanedCols,
            cleaningInfo, setCleaningInfo, dupCols, setDupCols, cleanFlag, setCleanFlag, menubar, setMenubar, showSidebar, setShowSidebar,
            noOfRowsAfterCleaning, setNoOfRowsAfterCleaning, noOfColsAfterCleaning, setNoOfColsAfterCleaning, balancedCols, setBalancedCols, actualFileName, setActualFileName, images, setImages, table1Data, setTable1Data, table2Data, setTable2Data, table3Data, setTable3Data, modelName, setModelName,openDrawer
        }}>
            <CssBaseline>
                <AppBar position="static" style={{height: "4rem", width: "100%", ...classes.appbar}}>
                    <Toolbar variant="dense" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="Open drawer"
                            style={{ paddingLeft: "0px", margin: "5px"}}
                        >
                            <Avatar aria-label="Logo" src={logo} style={{width: "100px", ...classes.avatar}} />
                        </IconButton>
                        <Typography style={{...classes.title}} variant="h6" noWrap>
                            <label >
                                NPD Sound and Vibration
                            </label>
                        </Typography>
                        {/* <Tooltip title="Click here for Help">
                            <h2 style={{ display: 'flex', marginRight: '1rem' }} onClick={handleHelpClick}>Help</h2>
                        </Tooltip> */}
                        <Box sx={{ flexGrow: 0 }} style={{margin: "0px"}}>
                            <Tooltip title={username}>
                                <IconButton
                                    onClick={handleClick}
                                    size="small"
                                    sx={{ ml: 2 }}
                                    aria-controls={open ? "account-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? "true" : undefined}
                                >
                                    <Avatar
                                        sx={{ width: 40, height: 40 }}
                                        style={{ backgroundColor: "silver" }}
                                    >
                                        {username
                                            ? username
                                                .split(" ")
                                                .map((word) => word.charAt(0).toUpperCase())
                                                .join("")
                                            : "UK"}
                                    </Avatar>
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Menu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleClose}
                            onClick={handleClose}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    overflow: "visible",
                                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                    mt: 1.5,
                                    "& .MuiAvatar-root": {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1,
                                    },
                                    "&::before": {
                                        content: '""',
                                        display: "block",
                                        position: "absolute",
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: "background.paper",
                                        transform: "translateY(-50%) rotate(45deg)",
                                        zIndex: 0,
                                    },
                                },
                            }}
                            transformOrigin={{ horizontal: "right", vertical: "top" }}
                            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                        >
                            {/*<MenuItem onClick={handleClose}>*/}
                            {/*  <Avatar /> Profile*/}
                            {/*</MenuItem>*/}
                            {/*<MenuItem onClick={handleClose}>*/}
                            {/*  <Avatar /> My account*/}
                            {/*</MenuItem>*/}
                            {/*<Divider />*/}
                            {/*<MenuItem onClick={handleClose}>*/}
                            {/*  <ListItemIcon>*/}
                            {/*    <PersonAdd fontSize="small" />*/}
                            {/*  </ListItemIcon>*/}
                            {/*  Add another account*/}
                            {/*</MenuItem>*/}
                            <div style={{ display: 'inline-grid', padding: '5px' }}>
                                {/* <MenuItem onClick={handleClose}>
                                    <ListItemIcon>
                                        <Settings fontSize="small" />
                                    </ListItemIcon>
                                    Settings
                                </MenuItem> */}
                                <MenuItem onClick={handleLogout}>
                                    <ListItemIcon>
                                        <Logout fontSize="small" />
                                    </ListItemIcon>
                                    Logout
                                </MenuItem>

                            </div>
                        </Menu>
                    </Toolbar>
                </AppBar>
            </CssBaseline>
            {/* <MiniDrawer/> */}
            <VerticalTabs fetchAPI={fetchAPI} path="/" />
        </SystemContext.Provider>
    );
}

export default SoundAndVibration;
